module.exports = __webpack_public_path__ + "img/bg10.e7657edf.png";